/**
 * Emulator Cores Registration
 * Registers all available cores with the factory
 */

import { EmulatorCoreFactory, EmulatorCoreType } from './EmulatorCoreFactory';
import { MelonDSCore } from './melonds/MelonDSCore';
import { DesmondCore } from './desmond/DesmondCore';

// Register melonDS core
EmulatorCoreFactory.registerCore(EmulatorCoreType.MELONDS, async () => {
  const core = new MelonDSCore();
  await core.initialize();
  return core;
});

// Register Desmond core
EmulatorCoreFactory.registerCore(EmulatorCoreType.DESMOND, async () => {
  const core = new DesmondCore();
  await core.initialize();
  return core;
});

// Export everything needed
export { EmulatorCoreFactory, EmulatorCoreType } from './EmulatorCoreFactory';
export { MelonDSCore } from './melonds/MelonDSCore';
export { DesmondCore } from './desmond/DesmondCore';
export type { IEmulatorCore, EmulatorState, EmulatorCoreMetadata } from './IEmulatorCore';
export { DSButton } from './IEmulatorCore';
export { CORE_REGISTRY, getCoreInfo, getRecommendedCore } from './registry';
